// extensions/FontSize.ts
import { Extension } from "@tiptap/core";
import {TextStyle} from "@tiptap/extension-text-style";

export const FontSize = Extension.create({
  name: "fontSize",

  addExtensions() {
    return [TextStyle];
  },

  addGlobalAttributes() {
    return [
      {
        types: ["textStyle"],
        attributes: {
          fontSize: {
            default: "18px", // ✅ DEFAULT SIZE HERE
            parseHTML: (element) =>
              element.style.fontSize || "18px",
            renderHTML: (attributes) => {
              if (!attributes.fontSize) return {};
              return {
                style: `font-size: ${attributes.fontSize}`,
              };
            },
          },
        },
      },
    ];
  },
});